import React from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../constants/Theme';

interface BadgeProps {
  children: React.ReactNode;
  backgroundColor?: string;
  fontColor: string;
}

const Badge: React.FC<BadgeProps> = ({
  children,
  backgroundColor = theme.colors.blue,
  fontColor = theme.colors.contrastWhite,
}) => {
  const classes = useStyles({ backgroundColor, fontColor });

  return <span className={`${classes.badge}`}>{children}</span>;
};

type StyleProps = {
  backgroundColor: string;
  fontColor: string;
};

const useStyles = createUseStyles({
  badge: {
    width: 'fit-content',
    padding: '5px 10px',
    borderRadius: theme.borderRadius.badge,
    fontFamily: theme.typography.fontFamily,
    backgroundColor: (props: StyleProps) => props.backgroundColor,
    color: (props: StyleProps) => props.fontColor,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: theme.typography.fontWeight.bold,
  },
});

export default Badge;
